import { yup } from 'common/validation/initYup';
import { ValidationSchema } from 'common/validation/ValidationSchema';
import { Type, Transform, plainToClass, classToPlain } from 'class-transformer';
import { TypeTransformDecimal } from 'common/dto/shared/types/TypeTransformDecimal';
import { Decimal } from 'decimal.js-light';
import { ApiProperty } from '@nestjs/swagger';
import type { IDto, IDtoPartial } from 'common/dto/shared/DtoInterfaces';
import { GenerateDto } from "cli/generate/decorators/GenerateDecorators";
import { SchemaLabel, SchemaReadonly } from "cli/generate/decorators/SchemaDecorators";

@GenerateDto()
class MandateGetDescriptionResponse {
  @SchemaLabel("Descrizione")
  @SchemaReadonly()
  description!: string;
  
}

/**
 * Rappresentazione DTO della classe MandateGetDescriptionResponse 
 * Hash: f33a1a2518ae1bd28f14dac0830a60f0
 */
@ValidationSchema(() => MandateGetDescriptionResponseSchema)
export class MandateGetDescriptionResponseDto {
  @ApiProperty({ type: String, description: 'Descrizione' })
  description!: string;

  /** Proprietà che identifica i DTO */
  readonly __dto!: any;

  /**
   * Crea una nuova istanza con i valori forniti
   */
  constructor(values?: IDtoPartial<MandateGetDescriptionResponseDto>) {
    if (values != null) {
      Object.assign(this, values instanceof MandateGetDescriptionResponseDto ? values : plainToClass(MandateGetDescriptionResponseDto, values));
    }
  }

  async validate(options?: any) {
    const validated = await MandateGetDescriptionResponseSchema.validate(classToPlain(this), options);
    return new MandateGetDescriptionResponseDto(validated);
  }
}

export const MandateGetDescriptionResponseSchema = yup
  .object({})
  .noUnknown()
  .meta({ schemaName: "MandateGetDescriptionResponseSchema" })
  .required();
